import React, { ButtonHTMLAttributes } from "react";
import { Button as Btn } from "antd";

//import Btn from 'antd/lib/button'
export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  /**
   * A label to show on the button
   */
  //label: string;
}

const Button = ({ children, ...rest }: ButtonProps) => (
  <div className={"demo"}>
    <Btn>{children}</Btn>
  </div>
);

export default Button;
